<section class="storyblok-blok-container">
  <div
    *ngIf="products?.length >= NUMBER_6"
    class='advanced-carousel advanced-carousel__title-plus-carousel'
    [ngClass]="computedClasses"
  >
    <header [ngClass]="{ 'promo-header': isPromo }">
      <h1 class="carousel-title">{{ title }}</h1>
      <mm-icon name="promo-icon" class="advanced-promo-icon" *ngIf="isPromo"></mm-icon>
    </header>

    <div class="carousel-container">
      <app-product-advanced-carousel
        class="carousel"
        [hasEndPadding]="hasEndPadding"
        [isMobile]="isMobile"
        [isDesktop]="!isMobile"
        [products]="products"
        [title]="title"
        [trackingName]="trackingName"
        (productClicked)="onProductClickEvent($event.product, $event.priceType, $event.index)"
        (productCarouselPrev)="onProductCarouselNavigation(DIRECTION.LEFT)"
        (productCarouselNext)="onProductCarouselNavigation(DIRECTION.RIGHT)"
        (swipeLeft)="onProductCarouselSwipe(DIRECTION.LEFT)"
        (swipeRight)="onProductCarouselSwipe(DIRECTION.RIGHT)"
      ></app-product-advanced-carousel>
    </div>
  </div>
</section>
